/**
 * Password rules and error reading, shared by the reset flow.
 *
 * Kept apart from apiAuth.js so a caller can use them without pulling axios in
 * — the same split as sharesFields.js next to apiContentSharing.js.
 */

export const MIN_PASSWORD_LENGTH = 8;

/**
 * The same checks the server makes, so the obvious mistakes never cost a
 * round trip. Returns an error message, or '' when the pair is acceptable.
 */
export function validateNewPassword(newPassword, confirmation, minLength = MIN_PASSWORD_LENGTH) {
  if (!newPassword) return 'Enter a new password';
  if (newPassword.length < minLength) {
    return `Password must be at least ${minLength} characters`;
  }
  if (newPassword !== confirmation) return 'The two passwords do not match';
  return '';
}

/**
 * Turn an error from either endpoint into one line for the user.
 *
 * 400 carries `{detail: "..."}`; 422 is FastAPI's validation shape, an array
 * of `{loc, msg}` where msg is prefixed with "Value error, ".
 */
export function passwordErrorMessage(err, fallback = 'Something went wrong. Please try again.') {
  if (err?.request && !err?.response) return 'Network error: Could not connect to server';

  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail) && detail.length > 0) {
    const msg = detail[0]?.msg;
    if (typeof msg === 'string') return msg.replace(/^Value error,\s*/, '');
  }
  return err?.response?.data?.message || fallback;
}
